import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin/enquiries" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin/enquiries");
    else setError(res.error);
  };

  return (
    <div className="sfm-grid-bg flex min-h-screen items-center justify-center bg-void px-5">
      <form
        onSubmit={submit}
        data-testid="login-form"
        className="w-full max-w-sm rounded-2xl border border-white/10 bg-obsidian p-8"
      >
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-amber/15 text-amber">
            <Lock size={18} />
          </div>
          <div>
            <h1 className="font-display text-xl font-bold uppercase text-white">Admin Login</h1>
            <p className="font-mono text-[10px] uppercase tracking-widest text-white/40">Enquiries Dashboard</p>
          </div>
        </div>

        <label className="mb-1.5 block font-mono text-[11px] uppercase tracking-widest text-white/50">Email</label>
        <input
          data-testid="login-email-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-4 w-full rounded-xl border border-white/10 bg-charcoal px-4 py-3 text-sm text-white outline-none focus:border-amber"
          placeholder="admin@shopfrontmakers.ie"
        />
        <label className="mb-1.5 block font-mono text-[11px] uppercase tracking-widest text-white/50">Password</label>
        <input
          data-testid="login-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-4 w-full rounded-xl border border-white/10 bg-charcoal px-4 py-3 text-sm text-white outline-none focus:border-amber"
          placeholder="••••••••"
        />

        {error && <p data-testid="login-error" className="mb-4 text-sm text-red-400">{error}</p>}

        <button
          type="submit"
          data-testid="login-submit-btn"
          disabled={loading}
          className="flex w-full items-center justify-center gap-2 rounded-full bg-amber py-3 font-display text-sm font-bold uppercase tracking-wide text-void transition-transform hover:scale-[1.01] hover:bg-amber-glow disabled:opacity-60"
        >
          {loading && <Loader2 className="animate-spin" size={16} />}
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default Login;
